import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-book-appointment-grid',
  templateUrl: './book-appointment-grid.component.html',
  styleUrls: ['./book-appointment-grid.component.css']
})
export class BookAppointmentGridComponent implements OnInit {
  title = "Appointment Details"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/book-appointment/book-appointment-grid/book-appointment-grid.component.ts